"use client"

import "bootstrap/dist/css/bootstrap.css";
import "../src/scss/_error.scss";
import '../src/scss/_reset.scss';
import "@fortawesome/fontawesome-free/css/all.css";
import ErrorPage from "@soprisapps/components/pages/ErrorPage";
import {Provider} from "@rollbar/react";
import {clientConfig} from "@soprisapps/components/components/utilities/rollbar/config";
import {ErrorBoundary} from "@soprisapps/components/components/utilities/rollbar/ErrorBoundary";
import Rollbar from "rollbar";

export default function Error({error, reset}) {

    return <html>
        <body>
            <Provider config={clientConfig} Rollbar={Rollbar}>
                <ErrorBoundary>
                    <ErrorPage />
                </ErrorBoundary>
            </Provider>
        </body>
    </html>
}